import React from "react";
import Holder from "./PopularLocation-Holder";
import "./PopularLocations.css";
const PopularLocation = () => {
  return (
    <>
      <div className="my-[5vh] flex flex-col justify-center">
        <div className="items-center align-center">
          <h1 className="text-center text-[33px] md:text-[45px] lg:text-[50px] font-bold mb-2 mt-5 text-black		">
            Popular Villas Nearby
          </h1>
        </div>
        <Holder />
      </div>
    </>
  );
};

export default PopularLocation;
